import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Map, ShieldAlert, CheckSquare, MessageSquare, Calendar } from 'lucide-react';
export function WhatsInside() {
  const chapters = [{
    icon: <BookOpen className="w-6 h-6 text-amber" data-id="element-205" />,
    title: 'The Meltdown Myth',
    desc: "Why your child's behavior is not a choice — and why that single shift changes how you respond forever"
  }, {
    icon: <Map className="w-6 h-6 text-amber" data-id="element-206" />,
    title: 'The Yellow Zone Map',
    desc: 'How to identify the 7 early warning signals before the point of no return — specific, observable, actionable'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-amber" data-id="element-207" />,
    title: 'The 3-Step Crisis Protocol',
    desc: 'The Caregiver Anchor, Sensory Load Reduction and Silent Co-Regulation — step by step, exactly as you apply them in real time'
  }, {
    icon: <CheckSquare className="w-6 h-6 text-amber" data-id="element-208" />,
    title: 'The Sensory Environment Audit',
    desc: 'A room-by-room checklist to reduce baseline load before triggers even appear'
  }, {
    icon: <MessageSquare className="w-6 h-6 text-amber" data-id="element-209" />,
    title: 'The School Advocacy Script',
    desc: 'Word-for-word language to use with teachers, aides and administrators so his needs are understood and protected'
  }, {
    icon: <Calendar className="w-6 h-6 text-amber" data-id="element-210" />,
    title: 'The 30-Day Reset Plan',
    desc: 'A practical daily framework that builds regulation capacity over time — fewer meltdowns, better sleep, calmer mornings'
  }];
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-211">
      <div className="max-w-5xl mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-214">
            What's Inside The Manual
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-215">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-dark p-6 md:p-8 rounded-2xl flex items-start space-x-4 hover:bg-amber-light transition-colors duration-300" data-id="element-216">
              <div className="bg-white p-3 rounded-xl shadow-sm shrink-0" data-id="element-217">
                {chapter.icon}
              </div>
              <div data-id="element-218">
                <h4 className="text-xl font-serif text-charcoal font-semibold mb-2" data-id="element-219">
                  {chapter.title}
                </h4>
                <p className="text-charcoal-light leading-relaxed" data-id="element-220">
                  {chapter.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}